import * as React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from '@emorg-prd/standard-react';
import { Grid, Button, Alert, TextInput, Textarea, Select } from '../../common';
import FormModel from '../../../utils/FormModel';
import SubmitFeedback from '../../../models/viewModels/Feedback/SubmitFeedback';
import { authenticatedUser } from '../../../authentication/authModule';
import FeedbackService from '../../../services/FeedbackService';
import './CreateFeedbackModal.css'

interface CreateFeedbackModalProps {
	visible: boolean;
	onConfirm: (event: React.ChangeEvent<any>) => void;
	onCancel?: (event: React.ChangeEvent<any>) => void;
	onClose: () => any;
}
interface CreateFeedbackModalState {
	title: string;
	description: string;
	category: string;
	loading: boolean;
	errorAlert: boolean;
}

export default class CreateFeedbackModal extends React.Component<
	CreateFeedbackModalProps,
	CreateFeedbackModalState
	> {
	form: FormModel;

	feedbackService: FeedbackService;

	constructor(props: CreateFeedbackModalProps) {
		super(props);
		this.state = {
			title: '',
			description: '',
			category: '',
			loading: false,
			errorAlert: false
		};
		this.feedbackService = new FeedbackService();
		this.form = new FormModel({
			title: {
				getValue: () => this.state.title,
				validation: {
					required: true,
				},
			},
			description: {
				getValue: () => this.state.description,
				validation: {
					required: true,
				},
			},
			category: {
				getValue: () => this.state.category,
				validation: {
					required: true,
				},
			}
		});
	}

	handleSubmitFeedback = async (e) => {

		const body = this.form.create(SubmitFeedback);

		body.submittedBy = authenticatedUser.userId;

		body.submitDate = new Date();

		this.setState({
			loading: true
		});
		this.feedbackService.SubmitFeedback(body).then(() => {
			this.setState({
				loading: false
			});
			this.props.onConfirm(e);
		}).catch(() => {
			this.setState({
				errorAlert: true,
				loading: false
			});
		});
	};

	componentDidUpdate = async (prevProps: CreateFeedbackModalProps) => {

		if (prevProps.visible == false && this.props.visible) {

			this.setState({ category: '', description: '', title: '' });
		}
	};

	componentDidMount() {
        const overlay = document.querySelector('.feedback-modal-position .em-c-modal__overlay');
        if (overlay) {
            const handler = (e: Event) => {
              e.stopPropagation(); // blocks closing by overlay
            };
            overlay.addEventListener('click', handler, true);
            // refs for cleanup
            (this as any)._overlay = overlay;
            (this as any)._overlayHandler = handler;
        }
    }
        
    componentWillUnmount() {
        const overlay = (this as any)._overlay as HTMLElement | undefined;
        const handler = (this as any)._overlayHandler as ((e: Event) => void) | undefined;
        overlay?.removeEventListener('click', handler!, true);
    }


	render() {
		return (<>
			<button
                type="button"
                className="em-js-modal-trigger"
                style={{ display: 'none' }}
                aria-hidden="true"
                >
                <span className="em-c-primary-nav__link" />
            </button>

			<Modal 
				show={this.props.visible}
				optionalClass='feedback-modal-position'
				onHide={() => { }}>
					<ModalHeader
						onClick={this.props.onClose}
						title={"Contact Us"}
					/>
					<ModalBody>
						<TextInput
							label="Title"
							value={this.state.title}
							validation={this.form.fields.title.validation}
							onChange={(event) => {
								this.setState({
									title: event.target.value,
								});
							}}
						/>
						<Select
							label="Category"
							value={this.state.category}
							options={['Bug', 'Comment', 'Question', 'Suggestion']}
							className="full-width"
							onChange={(e) => this.setState({ category: e.target.value })}
							validation={this.form.fields.category.validation}
						/>
						<Textarea
							label="Description"
							value={this.state.description}
							validation={this.form.fields.description.validation}
							onChange={(event) => {
								this.setState({
									description: event.target.value,
								});
							}}
							rows={3}
						/>
					</ModalBody>
					<ModalFooter>
						<Grid variant="2up">
							<Grid.Item>
								<Button 
									variant="secondary" 
									disabled={this.state.loading} 
									name='Cancel'
									onClick={this.props.onCancel || this.props.onClose}		
								>

								</Button>
							</Grid.Item>
							<Grid.Item>
								<Button
									variant='secondary'
									loadingVariant='secondary'
									isLoading={this.state.loading}
									onClick={this.handleSubmitFeedback}
									disabled={!this.form.isValid()}
									name='Submit'
								>
								</Button>
							</Grid.Item>
						</Grid>
						{this.state.errorAlert &&
							<Alert variant="error" onClose={() => this.setState({ errorAlert: false })} body='Something went wrong when trying to update the entry.'>
							</Alert>}
					</ModalFooter>
			</Modal>
		</>
		);
	}
}
